import { render } from "./NoticeList.vue?vue&type=template&id=3be84f49&ts=true"
import script from "./NoticeList.vue?vue&type=script&lang=ts"
export * from "./NoticeList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__